<template>
  <div
    class="bg-white shadow-sm rounded-md py-6 print:py-0 px-4 lg:px-8 mt-4 print:shadow-none"
  >
    <h2 class="text-xl font-bold">{{@heading}}</h2>
    {{yield}}
  </div>
</template>
